import Controller from './controller.js';

let lastTime;
let controller;

function init() {
	lastTime = Date.now();
	controller = new Controller('#header-background');

	handleResize();
	// Set up event listeners.
	window.addEventListener('resize', handleResize);
	// Kick off the update loop
	window.requestAnimationFrame(everyFrame);

	window.addEventListener('mousemove', handleMouseEvent)
}

// TODO: Make tweak this to allow frame skipping for slow computers. Maybe.
function everyFrame() {
	update();
	render();
	requestAnimationFrame(everyFrame);
}

function update() {
	let curTime = Date.now();
	let dt = (curTime - lastTime) / 1000;
	controller.update(dt);
	lastTime = curTime;
}

function render() {
	controller.clear();
	controller.render();
}

function handleResize() {
	controller.resize();
}

function handleMouseEvent(evt) {
	controller.onMouseInput({x: evt.clientX, y: evt.clientY});
}

init();


// WEBPACK FOOTER //
// ./src/js/main.js